import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { EligibilityRoutingModule } from './eligibility-routing.module';
import { EligibilityListComponent } from './eligibility-list/eligibility-list.component';
import { EligibilityCreateComponent } from './eligibility-create/eligibility-create.component';

@NgModule({
  declarations: [EligibilityListComponent, EligibilityCreateComponent],
  imports: [
    CommonModule,
    EligibilityRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class EligibilityModule { }
